module.exports = __webpack_public_path__ + "img/1517325073.af01b4e7.jpg";